import Cookie from 'js-cookie';
import axios from 'axios';
// import { Env } from '@stencil/core';

async function fetchUserProfile(env) {

	const BTSESSION = Cookie.get("BTSESSION");

	const userSessionApi = `${env}/service/user/session/user`;

	if (BTSESSION && typeof BTSESSION != 'undefined') {
		try {
			const response = await axios.get(
			userSessionApi,
			{
				headers: {
					'Accept': 'application/json',
					'Cookie': 'BTSESSION=' + BTSESSION,
					'X-BrightTALK-access': 'niHeeF1ao2',
					'Content-Type': 'application/json',
					'BrightTALK-API-Client': 'wordpress'
				},
				withCredentials: true

			}
			);
			// console.log("success");
			// console.log(response.data);
			return updateUserState(response);
		} catch (error) {
			console.log("error");
			console.log(error);
		}
	}

}

export function updateUserState(response){

	const data = response.data;

	// Check if response returns any roles for user.
	let roles = false
	if (data['roles'] !== undefined){
		if (data['roles'].includes("manager") || data['roles'].includes("operations")){
			roles = true
		}
	}

	//
	let preAuth = false
	if (data['preAuth'] !== undefined || data['preAuth'] === true ){
		preAuth = true
	}

	if (data){
		return {
			isLoggedIn: true,
			isManager: roles,
			preAuth: preAuth
		}
	}
}

export default fetchUserProfile;